import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=0c802440&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=0c802440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c802440",
  null
  
)

export default component.exports